import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { I9HubProvider } from '../context/I9HubProvider'
import { I9ManagementMain } from './components/I9ManagementMain'

export const I9Management = () => (
  <NuqsAdapter>
    <I9HubProvider>
      <I9ManagementMain />
    </I9HubProvider>
  </NuqsAdapter>
)
